import { createStore, applyMiddleware } from 'redux';
import rootReducer from './reducers';
import { StateLoader } from './StateLoader';
import { thunk } from 'redux-thunk';

const stateLoader = new StateLoader();

const state = stateLoader.loadState();
const store = createStore(rootReducer, state, applyMiddleware(thunk));

store.subscribe(() => {
    stateLoader.saveState(store.getState());
});

export default store;
